/* eslint-disable */
import axios from "axios";
import { sameValue } from "../../utils/storeDraft";

// const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = "https://backend-foorweb-nevzx.ondigitalocean.app/apis";
// const API_BASE_URL = "http://localhost:2086/apis";

const isForbidden = (error) => error?.response?.status === 403;

const workerAPI = {
  getAuthToken: () => {
    return localStorage?.getItem("token");
  },

  getAuthParams: () => {
    return { user: workerAPI.getAuthToken() };
  },

  //get owner account
  getOwnerAccount: async () => {
    try {
      const token = workerAPI.getAuthToken();
      const response = await axios.get(`${API_BASE_URL}/owner/account`, {
        params: { user: token },
      });
      return response?.data?.account ?? {};
    } catch (error) {
      if (isForbidden(error)) {
        return {};
      }
      throw error;
    }
  },
  // Get orders
  getOrders: async (startDate, endDate) => {
    try {
      console.log("Fetching orders with startDate:", startDate, "endDate:", endDate);
      const token = workerAPI.getAuthToken();
      const params = { user: token };

      if (startDate) {
        params.startDate = startDate.toMillis
          ? startDate.toMillis()
          : startDate;
      }

      if (endDate) {
        params.endDate = endDate.toMillis ? endDate.toMillis() : endDate;
      }

      const response = await axios.get(`${API_BASE_URL}/orders`, {
        params,
      });
      return response.data?.orders ?? [];
      console.log("Orders fetched successfully:", response.data.orders);
    } catch (error) {
      console.error("Error fetching orders:", error);
      if (isForbidden(error)) {
        return [];
      }
      throw error;
    }
  },

  createOrder: async (orderData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/orders`, orderData, {
        params: workerAPI.getAuthParams(),
      });
      return response.data;
    } catch (error) {
      if (isForbidden(error)) return null;
      throw error;
    }
  },

  updateOrder: async (orderId, orderData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/orders/${orderId}`,
        orderData,
        { params: workerAPI.getAuthParams() }
      );
      return response.data;
    } catch (error) {
      if (isForbidden(error)) return null;
      throw error;
    }
  },  

  // Delete order
  // Delete order
  deleteOrder: async (orderId, orderData) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/orders/${orderId}`, {
        params: workerAPI.getAuthParams(),
        data: orderData,
      });
      return response.data;
    } catch (error) {
      if (isForbidden(error)) return false;
      throw error;
    }
  },

  // Get products
  getProducts: async () => {
    try {
      const token = workerAPI.getAuthToken();
      const response = await axios.get(`${API_BASE_URL}/products`, {
        params: { user: token },
      });
      return response.data?.products ?? [];
    } catch (error) {
      if (isForbidden(error)) {
        return [];
      }
      throw error;
    }
  },
  getProductsByOrderId: async (orderId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/products`, {
        params: {
          ...workerAPI.getAuthParams(),
          orderId,
        },
      });
      return response.data?.products ?? [];
    } catch (error) {
      if (isForbidden(error)) return [];
      throw error;
    }
  },

  createProduct: async (productData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/products`,
        productData,
        { params: workerAPI.getAuthParams() }
      );
      return response.data?.product ?? {};
    } catch (error) {
      if (isForbidden(error)) return null;
      throw error;
    }
  },
  updateProduct: async (productId, productData) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/products/${productId}`,
        productData,
        { params: workerAPI.getAuthParams() }
      );
      return response.data?.product ?? {};
    } catch (error) {
      if (isForbidden(error)) return null;
      throw error;
    }
  },

  deleteProduct: async (productId) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/products/${productId}`,
        {
          params: workerAPI.getAuthParams(),
        }
      );
      return response.data?.product ?? {};
    } catch (error) {
      if (isForbidden(error)) return false;
      throw error;
    }
  },

  // Get store
  getStore: async () => {
    try {
      const token = workerAPI.getAuthToken();
      const response = await axios.get(`${API_BASE_URL}/store`, {
        params: { user: token },
      });
      return response.data.store;
    } catch (error) {
      if (isForbidden(error)) {
        return {};
      }
      throw error;
    }
  },

  //update store
  updateStore: async (storeData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/store`, storeData, {
        params: workerAPI.getAuthParams(),
      });
      return response.data;
    } catch (error) {
      if (isForbidden(error)) return null;
      throw error;
    }
  },

  // Existing /store consumers already send partial, top-level updates.
  updateStoreDraft: async (source, draft) => {
    const patch = Object.fromEntries(Object.entries(draft).filter(
      ([key, value]) => key !== "id" && !sameValue(source?.[key], value),
    ));
    if (Object.keys(patch).length === 0) return { store: source };
    const result = await workerAPI.updateStore(patch);
    if (!result?.store) throw new Error("Store update was not accepted");
    // A response must not replace unrelated live statistics in Redux.
    const savedFields = Object.fromEntries(Object.keys(patch).map(
      (key) => [key, result.store[key]],
    ));
    return { ...result, store: { ...source, ...savedFields } };
  },

  // Get digital store
  getDigitalStore: async () => {
    try {
      return {};
    } catch (error) {
      if (isForbidden(error)) {
        return {};
      }
      throw error;
    }
  },
};

export default workerAPI;
